import * as Effects from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import { fireToastError } from '../../actions/toasts/fireToast'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'
import { IntegrationAction } from '../../reducers/airbnb/actionNames'
import saveAirbnbConfiguration from '../../models/Integration/saveAirbnbConfiguration'
import { getUserLanguage } from '../../reducers/userAccount/selectors/userAccount'
import { mapLangToGoogleTranslate } from './createListing'

function* saveConfiguration(action) {
  yield Effects.put({
    type: IntegrationAction.ToggleSavingConfiguration,
    payload: true,
  })

  try {
    const actionNames = fetchActionsName(ActionNames.SaveAirbnbConfiguration)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(
          actionNames.input,
          actionNames.output,
          saveAirbnbConfiguration,
        ),
      ),
    ])

    const mobile = action.values.mobile

    delete action.values.mobile
    delete action.values.pricing.listing_currency

    localStorage.setItem(
      'airbnb_attestation',
      action.values.attestation ? '1' : '0',
    )

    const conf = {
      id_room: action.values.id_room,
      listing: {
        has_availability: action.values.listing.has_availability,
        //listing_currency: action.values.pricing.listing_currency,
        //listing_price: action.values.pricing.default_daily_price,
      },
      pricing: {
        ...action.values.pricing,
        cleaning_fee: undefined,
        default_daily_price: Number(action.values.pricing.default_daily_price),
        listing_currency: action.values.pricing.listing_currency,
        standard_fees: action.values.pricing.standard_fees.map(f => ({
          ...f,
          offline: f.offline,
          amount_type: String(f.amount_type).toUpperCase(),
          fee_unit_type: f.fee_unit_type ? f.fee_unit_type : undefined,
          amount:
            String(f.amount_type).toUpperCase() === 'PERCENT'
              ? Number(f.amount)
              : Number(f.amount) * 1000000,
        })),
        pass_through_taxes: action.values.pricing.pass_through_taxes.map(p => ({
          ...p,
          attestation: 'true',
          amount: Number(p.amount),
          tot_registration_id: p.tot_registration_id
            ? p.tot_registration_id
            : p.no_tot_registration_id_declaration
            ? null
            : undefined,
          business_tax_id: p.business_tax_id
            ? p.business_tax_id
            : p.no_business_tax_id_declaration
            ? null
            : undefined,
          long_term_stay_exemption: p.only_first_nights_exemption_switch
            ? null
            : Number(p.long_term_stay_exemption) === 0
            ? null
            : p.long_term_stay_exemption,
          only_first_nights_exemption:
            p.only_first_nights_exemption_switch &&
            p.long_term_stay_exemption_switch &&
            Number(p.long_term_stay_exemption) !== 0
              ? p.long_term_stay_exemption
              : null,
          long_term_stay_exemption_switch: undefined,
          only_first_nights_exemption_switch: undefined,
          max_cap_per_person_per_night_switch: undefined,
          taxable_base: p.taxable_base
            ? Object.entries(p.taxable_base)
                .map(([key, value]) => (value ? key : undefined))
                .filter(Boolean)
            : undefined,
        })),
        default_pricing_rules: action.values.pricing.default_pricing_rules.map(
          r => ({
            ...r,
            price_change_type: 'PERCENT',
            price_change:
              Number(r.price_change) < 0 ? r.price_change : r.price_change * -1,
          }),
        ),
      },
      availability: {
        ...action.values.availability,
        max_days_notice: undefined,
        day_of_week_check_in: action.values.availability.day_of_week_check_in
          .map((v, i) => ({ day_of_week: v ? undefined : i }))
          .filter(v => (v.day_of_week !== undefined ? v : undefined)),
        day_of_week_check_out: action.values.availability.day_of_week_check_out
          .map((v, i) => ({ day_of_week: v ? undefined : i }))
          .filter(v => (v.day_of_week !== undefined ? v : undefined)),
        max_days_notice_rule: {
          days:
            action.values.availability.max_days_notice_rule == null ||
            action.values.availability.max_days_notice_rule.days === '' ||
            action.values.availability.max_days_notice_rule.days == null
              ? -1
              : Number(action.values.availability.max_days_notice_rule.days),
          allow_rtb_beyond_max_days_notice: Boolean(
            action.values.availability.max_days_notice_rule &&
              action.values.availability.max_days_notice_rule
                .allow_rtb_beyond_max_days_notice,
          ),
        },
      },
    }
    const lang = yield Effects.select(getUserLanguage)

    yield Effects.call(service, conf, mapLangToGoogleTranslate(lang))

    yield Effects.put({
      type: IntegrationAction.ToggleSavingConfiguration,
      payload: false,
    })

    if ('routerHistory' in window) {
      ;(window as any).routerHistory.push({
        pathname: mobile
          ? '/integration/airbnb?mobile=1'
          : '/integration/airbnb',
        state: { force: true },
      })
    }
  } catch (e) {
    console.error(e)

    yield Effects.put({
      type: IntegrationAction.ToggleSavingConfiguration,
      payload: false,
    })

    yield Effects.put(fireToastError(e.message, 5000, 'Main', 'ServerError'))
  }
}

export default function*() {
  yield Effects.takeLatest(
    IntegrationAction.SaveRoomConfiguration,
    saveConfiguration,
  )
}
